import { render } from "./OrderPlaced.vue?vue&type=template&id=8199a3e4&scoped=true"
import script from "./OrderPlaced.vue?vue&type=script&lang=js"
export * from "./OrderPlaced.vue?vue&type=script&lang=js"

import "./OrderPlaced.vue?vue&type=style&index=0&id=8199a3e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8199a3e4"]])

export default __exports__